import { Box, styled } from '@mui/material';
import React from 'react';

const StyledFormControlsWrapper = styled(Box)(({ theme }) => ({
    marginBottom: '24px',
    [theme.breakpoints.up('md')]: {
        display: 'flex',
        flex: '0 0 50%',
        width: '100%',
        columnGap: '10px',
        marginBottom: '12px',
    },
}));

export const FormControlsWrapper: React.FC<{ children: React.ReactNode }> = (
    props
) => {
    return (
        <StyledFormControlsWrapper>{props.children}</StyledFormControlsWrapper>
    );
};
